import { BroadcastError } from '@clearkit/icons';
import { CKButton } from 'clearkit';

import * as Well from './Well';

type ListLoadError = {
  onRetry: () => void;
};
export function ListLoadError({ onRetry }: ListLoadError) {
  return (
    <Well.Root>
      <Well.Icon>
        <BroadcastError className="text-red" />
      </Well.Icon>
      <Well.Content>
        <Well.Heading>
          Error retrieving your custom objects from Salesforce
        </Well.Heading>
        <Well.Paragraph>
          We attempted to retrieve your custom objects from Salesforce and
          encountered an error. Please make sure you have a valid connection to
          Salesforce. {/** TODO: Check their account connection here as well */}
        </Well.Paragraph>
        <Well.Paragraph>
          If the issue persists, please contact{' '}
          <a href="mailto:support@clearbit.com">support@clearbit.com</a>.
        </Well.Paragraph>
        <CKButton onClick={onRetry} variantColor="blue">
          Retry fetching custom objects
        </CKButton>
      </Well.Content>
    </Well.Root>
  );
}
